import Mixpanel from 'mixpanel-browser'
import { get } from 'lodash'
import update from 'immutability-helper'

import { guid } from 'helpers/index'

export function add (data) {
  data.id = guid()

  Mixpanel.track('Added to Cart', {
    date: get(data, 'date'),
    customer_name: get(data, 'customer.name'),
    route_name: get(data, 'customer.name'),
    product_name: get(data, 'product.name'),
    qty: get(data, 'qty'),
    uom_name: get(data, 'uom.name'),
    option_name: get(data, 'option.name'),
    notes: get(data, 'notes')
  })

  return {
    type: 'STAGING_ADD',
    id: data.id,
    data,
    notify: {
      type: 'notice',
      showClose: false,
      timeout: 1000,
      message: 'Added a product to your cart!'
    }
  }
}

export function edit (id, data) {  
  return {
    type: 'STAGING_EDIT',
    id,
    data
  }
}

export function commit () {
  Mixpanel.track('Sent Cart to TwoXSea')

  return {
    type: 'STAGING_COMMIT'
  }
}

export function destroy (id) {
  Mixpanel.track('Destroyed an Item in the Cart')

  return {
    type: 'STAGING_DESTROY',
    id
  }
}

export function wipe () {
  Mixpanel.track('Cleared Cart')

  return {
    type: 'STAGING_WIPE'
  }
}

export const actions = {
  add,
  edit,
  commit,
  destroy,
  wipe
}

// Action Handlers
const ACTION_HANDLERS = {
  STAGING_ADD: (state, action) => {
    if (!Array.isArray(state)) state = []
    state = state.filter(o => o.id !== action.id) // filter out the product we're currently adding..
    state.push(action.data)

    return state
  },
  STAGING_EDIT: (state, action) => {
    let found = state.findIndex(model => model.id === action.id)
    if (found < 0 || !state[found]) return state

    return update(
      state,
      { [found]: { $set: action.data } }
    )
  },
  STAGING_COMMIT: (state, action) => {
    return [] // returns state
  },
  STAGING_DESTROY: (state, action) => {
    return state.filter(o => o.id !== action.id) // filter when id is the destroyed one and return the rest
  },
  STAGING_WIPE: (state, action) => {
    return []
  }
}

// Reducer
const initialState = []

// NOTE: This `reducer` doesn't seem to be going anywhere....
export default function (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/Orders/modules/staging.js